export default {
    distanceError: 30, // Distancia máxima en metros de error al chequear puntos de control
}